import React from 'react';

import EditIcon from '@mui/icons-material/Edit';
import { Box, Button } from '@sunwisesoftware/sunwise-ui';
import { push } from 'connected-react-router';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { POLYGON_SEGMENT } from 'common/components/segment/constants';
import PanelsCard from 'common/components/segment/PanelsCard';
import { PROPOSAL_STATUS } from 'common/constants';

import * as actions from '../actions';
import * as selectors from '../selectors';

import SegmentsListCard from './SegmentsListCard';

const SegmentsBar = ({
    commercialOfferId,
    generateProposal,
    handleClickEdit,
    handleOnDuplicateSegment,
    isDisabledEdition,
    isEditionMode,
    offerInfoPaternData,
    offerPanels,
    offerPanelsCounters,
    onCloseDrawer,
    prepareDeleteSegment,
    prepareEditSegment,
    proposalId,
    redirect,
    renderStatus,
    segments,
    selectedSegmentId,
    selectSegment,
    setAddSegmentModalOpenStatus,
    updateSegments,
}) => {
    const { t } = useTranslation();

    const deleteCallback = () => {
        onCloseDrawer();
    };

    return (
        <Box px={1}>
            <Box py={1}>
                {renderStatus === PROPOSAL_STATUS.GENERATED ? (
                    <Box sx={{ display: 'flex', gap: 2 }}>
                        <Button
                            fullWidth
                            onClick={() =>
                                redirect(`/panel-layout/preview/${proposalId}`)
                            }
                        >
                            {t('Preview')}
                        </Button>
                        <Button
                            fullWidth
                            onClick={() =>
                                handleClickEdit(commercialOfferId, proposalId)
                            }
                            endIcon={<EditIcon />}
                            variant="outlined"
                        >
                            {t('Edit')}
                        </Button>
                    </Box>
                ) : (
                    <Button
                        fullWidth
                        onClick={() => generateProposal(proposalId)}
                    >
                        {t('Generate report')}
                    </Button>
                )}
            </Box>

            <PanelsCard offerPanels={offerPanels} segments={segments} />

            <SegmentsListCard
                commercialOfferId={commercialOfferId}
                handleClickAdd={({ type = null } = {}) => {
                    if (type === POLYGON_SEGMENT)
                        setAddSegmentModalOpenStatus(true);
                    onCloseDrawer();
                }}
                handleClickDelete={(id) =>
                    prepareDeleteSegment(deleteCallback, id)
                }
                handleClickEditSegment={prepareEditSegment}
                handleOnDuplicateSegment={handleOnDuplicateSegment}
                handleSelectSegment={selectSegment}
                isDisabledEdition={isDisabledEdition}
                isEditionMode={isEditionMode}
                offerInfoPaternData={offerInfoPaternData}
                offerPanels={offerPanels}
                offerPanelsCounters={offerPanelsCounters}
                onCloseDrawer={onCloseDrawer}
                segments={segments}
                selectedSegmentId={selectedSegmentId}
                updateSegments={updateSegments}
            />
        </Box>
    );
};

const mapStateToProps = createStructuredSelector({
    offerInfoPaternData: selectors.getOfferInfoPaternData,
    offerPanelsCounters: selectors.getOfferPanelsCounters,
    parentFieldSegmentCounters: selectors.getParentFieldSegmentCounters,
    selectedSegmentId: selectors.getSelectedSegmentId,
});

const mapDispatchToProps = (dispatch) => ({
    handleOnDuplicateSegment: (item, commercialOfferId) =>
        dispatch(actions.handleOnDuplicateSegment(item, commercialOfferId)),
    prepareDeleteSegment: (callback, id) =>
        dispatch(actions.prepareDeleteSegment(callback, id)),
    prepareEditSegment: (values) => dispatch(actions.setInitialValues(values)),
    redirect: (link) => dispatch(push(link)),
    resetForm: () => dispatch(actions.resetForm()),
    selectSegment: (segment) => dispatch(actions.selectSegment(segment)),
    setAddSegmentModalOpenStatus: (isOpen) =>
        dispatch(actions.setAddSegmentModalOpenStatus(isOpen)),
    updateSegments: (values) => dispatch(actions.updateSegments(values)),
});

SegmentsBar.propTypes = {
    commercialOfferId: PropTypes.string,
    generateProposal: PropTypes.func,
    handleClickEdit: PropTypes.func,
    handleOnDuplicateSegment: PropTypes.func,
    isDisabledEdition: PropTypes.bool,
    isEditionMode: PropTypes.bool,
    offerInfoPaternData: PropTypes.object,
    offerPanels: PropTypes.array,
    offerPanelsCounters: PropTypes.object,
    onCloseDrawer: PropTypes.func,
    prepareDeleteSegment: PropTypes.func,
    prepareEditSegment: PropTypes.func,
    proposalId: PropTypes.string,
    redirect: PropTypes.func,
    renderStatus: PropTypes.string,
    segments: PropTypes.array,
    selectedSegmentId: PropTypes.string,
    selectSegment: PropTypes.func,
    setAddSegmentModalOpenStatus: PropTypes.func,
    updateSegments: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(SegmentsBar);
